<script>

import { Doughnut } from 'vue-chartjs'
import store from 'vuex-store'
import urlApi from '../../../../router/urlApi'
import Vue from 'vue'

let palette = store.getters.palette

export default {
  extends: Doughnut,
  data () {
    return {
      qtdAulas: 45,
      chartData: {
        labels: ['Aulas Feitas',	'Aulas Faltantes'],
        datasets: [{
          backgroundColor: [palette.info],
          data: [0, 0]
        }]
      },
      options: {
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            fontColor: palette.fontColor,
            fontFamily: 'sans-serif',
            fontSize: 13,
            usePointStyle: true
          }
        },
        tooltips: {
          bodyFontSize: 15,
          bodyFontFamily: 'sans-serif'
        },
        responsive: true,
        maintainAspectRatio: false,
        fontSize: 20
      }
    }
  },
  async mounted () {
    await Vue.http.get(urlApi + '/ead/profile').then((response) => {
      this.chartData.datasets[0].data[0] = response.body.aulas_teoricas.presencas_aulas_teoricas
      this.chartData.datasets[0].data[1] = this.qtdAulas - response.body.aulas_teoricas.presencas_aulas_teoricas // 45 é a soma de todos os conteudos
    })
    this.renderChart(this.chartData, this.options)
  },

}
</script>
